import { parseFilter, stringifyFilter } from "../../utils/queryUtils";

export const ENABLED_REPORTING_DATE_MODULES = ["csv_fr", "saft_fr"];
export const REPORTING_DATE_FILTER_COLUMN = "ReportDate";
export const REPORTING_DATE_FILTER_MASK = "yyyy-MM-dd";
export const REPORTING_DATE_FILTER_OPERATOR = "between";
export const REPORTING_DATE_FILTER_COLUMNS = [
    REPORTING_DATE_FILTER_COLUMN,
];

export const createReportingDateStorageKey = ({ projectId }) => {
    return ["report_date_filter", projectId || ""].join("_");
};

export const isReportingDateHeaderEnabled = ({ modulePrefix, modules }) => {
    return modules?.includes("new_navigation") && ENABLED_REPORTING_DATE_MODULES.includes(modulePrefix);
};

export const hasReportingDateAvailableFilter = (availableFilters = []) => {
    return availableFilters?.some?.(({ prop }) => REPORTING_DATE_FILTER_COLUMNS.includes(prop));
};

export const normalizeFilterList = (filter) => {
    const parsedFilter = Array.isArray(filter) ? filter : parseFilter(filter);
    return Array.isArray(parsedFilter) ? parsedFilter : [];
};

export const hasReportingDateFilter = (filter) => {
    return normalizeFilterList(filter).some(({ column }) => REPORTING_DATE_FILTER_COLUMNS.includes(column));
};

export const parseReportingDateRangeFromFilters = (filter) => {
    const filters = normalizeFilterList(filter);
    const reportingDateFilter = filters.find(({ column }) => REPORTING_DATE_FILTER_COLUMNS.includes(column));
    const filterValue = reportingDateFilter?.filters?.[0]?.value || "";
    const [from = null, to = null] = filterValue.split("#");

    return {
        from: from || null,
        to: to || null,
    };
};

export const upsertReportingDateFilter = (filter, nextRange) => {
    const filters = normalizeFilterList(filter).filter(
        ({ column }) => !REPORTING_DATE_FILTER_COLUMNS.includes(column),
    );
    const { from = null, to = null } = nextRange || {};

    if (!from && !to) {
        return filters;
    }

    return [
        ...filters,
        {
            column: REPORTING_DATE_FILTER_COLUMN,
            filters: [{ value: `${from || ""}#${to || ""}` }],
            mask: REPORTING_DATE_FILTER_MASK,
            operator: REPORTING_DATE_FILTER_OPERATOR,
        },
    ];
};

export const buildSearchWithReportingDate = (search, nextRange) => {
    const searchParams = new URLSearchParams(search);
    const nextFilters = upsertReportingDateFilter(searchParams.get("filter"), nextRange);

    if (nextFilters.length) {
        searchParams.set("filter", stringifyFilter(nextFilters));
    } else {
        searchParams.delete("filter");
    }

    searchParams.delete("page");

    return searchParams.toString();
};

export const buildSearchWithoutReportingDate = (search) => {
    const searchParams = new URLSearchParams(search);
    const nextFilters = upsertReportingDateFilter(searchParams.get("filter"), null);

    if (nextFilters.length) {
        searchParams.set("filter", stringifyFilter(nextFilters));
    } else {
        searchParams.delete("filter");
    }

    searchParams.delete("page");

    return searchParams.toString();
};

export const getStoredReportingDateRange = (storageKey) => {
    try {
        const storedRange = sessionStorage.getItem(storageKey);

        if (!storedRange) {
            return null;
        }

        const parsedStoredRange = JSON.parse(storedRange);

        if (!parsedStoredRange || typeof parsedStoredRange !== "object") {
            sessionStorage.removeItem(storageKey);
            return null;
        }

        return {
            from: parsedStoredRange.from || null,
            to: parsedStoredRange.to || null,
        };
    } catch (_) {
        try {
            sessionStorage.removeItem(storageKey);
        } catch (_) {
            return null;
        }

        return null;
    }
};

export const setStoredReportingDateRange = (storageKey, nextRange) => {
    try {
        if (nextRange?.from || nextRange?.to) {
            sessionStorage.setItem(storageKey, JSON.stringify(nextRange));
            return;
        }

        sessionStorage.removeItem(storageKey);
    } catch (_) {
        return;
    }
};
